import styles from './index.module.less';
import { useTranslation } from 'next-i18next';
import { UnAddAccountModel } from '@/types/home';

const AddAccountContent = ({
  item,
  onAddAccountClick,
}: {
  item: UnAddAccountModel;
  onAddAccountClick?: (data: UnAddAccountModel) => void;
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.content}>
      <div className={styles.leftContainer}>
        <span>{/* <PlusOutlined /> */}</span>
        <div className={styles.infoContainer}>
          <span>{item?.item_name}</span>
          <p>{t('You have one more tracking slot available. Add that important Instagram account to you.')}</p>
        </div>
      </div>

      <div className={styles.rightContainer}>
        <span
          onClick={() => {
            if (onAddAccountClick) {
              onAddAccountClick(item);
            }
          }}
        >
          {t('ADD ACCOUNT')}
        </span>
      </div>
    </div>
  );
};

export default AddAccountContent;
